import React from 'react';
import { ValueEditor, ValueEditorProps } from 'react-querybuilder';
import { defaultNullRelatedOperators } from './constants';

const nullOperators = [
  defaultNullRelatedOperators.notNull,
  defaultNullRelatedOperators.null,
];

export default (props: ValueEditorProps) => {
  const { rule } = props;

  if (nullOperators.includes(rule?.operator)) {
    return null;
  }

  return <ValueEditor {...props} />;
};
